import DateTime from "../DateTime/DateTime";
import EcgIcon from "../EcgIcon/EcgIcon";

type EcgDateTimeProps = {
  date?: string;
  hideIcon?: boolean;
  showTime?: boolean;
  isEcgArchived?: boolean;
  ecgHasSymptoms?: boolean;
  isEcgUnreadable?: boolean;
};

const EcgDateTime = ({
  date,
  hideIcon,
  showTime,
  isEcgArchived,
  ecgHasSymptoms,
  isEcgUnreadable,
}: EcgDateTimeProps) => {
  return (
    <div className="d-flex align-items-center">
      {!hideIcon && (
        <EcgIcon
          isEcgArchived={!!isEcgArchived}
          ecgHasSymptoms={!!ecgHasSymptoms}
          isEcgUnreadable={!!isEcgUnreadable}
        />
      )}
      <span className="mx-sm"></span>

      <DateTime showTime={showTime}>{date}</DateTime>
    </div>
  );
};

export default EcgDateTime;
